import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RolDto } from '../dto/justino/rol.dto';
import { environment } from '../../environments/environment';
import { Constants } from '../constants/constants';

@Injectable({
  providedIn: 'root'
})
export class RolService {

  private apiUrl = `${environment.justinoApiUrl}/api/roles/`;

  constructor(
    private http: HttpClient) {}

  getHeaders() {
    const authToken = sessionStorage.getItem(Constants.ACCESS_TOKEN) ?? '';
    return { 
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`,
    };
  }

  getRoles(): Observable<RolDto[]> {
    return this.http.get<RolDto[]>(this.apiUrl, { headers: this.getHeaders() });
  }

  getRolById(id: string): Observable<RolDto> {
    return this.http.get<RolDto>(`${this.apiUrl}${id}`, { headers: this.getHeaders() });
  }

  createRol(rol: RolDto): Observable<RolDto> {
    return this.http.post<RolDto>(this.apiUrl, rol, { headers: this.getHeaders() });
  }

  updateRol(id: string, rol: RolDto): Observable<RolDto> {
    return this.http.put<RolDto>(`${this.apiUrl}${id}`, rol, { headers: this.getHeaders() });
  }

  deleteRol(id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}${id}`, { headers: this.getHeaders() });
  }
}
